/**
 * The live Verizon Home Device Protect offer SKU — `ProductSku.VerizonHomeDeviceProtectAccountLevel`
 * ('3002') in ASP/product-config (partner `verizon`; the static fios `VZN_VHDP` is a different SKU).
 *
 * VHDP is the Long Form AI pilot offer: the narrative container only replaces the offer checklist
 * when this product is the selected offer. The enum itself lives in the sales-domain repo and isn't
 * importable here, so the SKU is pinned as a literal.
 */
export const VHDP_PRODUCT_SKU = "3002";
